import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sort-down",
  "use": "icon-sort-down-usage",
  "viewBox": "0 0 9 10",
  "content": "<symbol viewBox=\"0 0 9 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort-down\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.281 9.75L3.74193e-07 5.46975L1.0605 4.4085L3.53516 6.88316L3.53516 -4.39334e-07L5.03516 -3.08199e-07L5.03516 6.87449L7.5 4.4085L8.5605 5.46975L4.281 9.75Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol